export const articles = [
    {
        url: 'https://blog.udemy.com/how-to-plan-your-career-change/',
        title: 'Career Transitions & Changes: Pursuing a New Career Path',
        author: 'Heather Ishikawa',
        thumbnail: 'https://blog.udemy.com/wp-content/uploads/2024/11/Heather_Ishikawa-160x160.jpg',
        minutesToRead: 9,
    },
    {
        url: 'https://blog.udemy.com/types-of-artificial-intelligence/',
        title: 'Types of Artificial Intelligence',
        author: 'Genefa Murphy',
        thumbnail:
            'https://frontends.udemycdn.com/frontends-marketplace-experience/staticx/udemy/images/author-thumbnails/genefa_murphy_author_photo.png',
        minutesToRead: 21,
    },
    {
        url: 'https://blog.udemy.com/accelerate-your-career-growth-with-udemy-ai-assistant/',
        title: 'Accelerate Your Career Growth with Udemy AI Assistant',
        author: 'Udemy Team',
        thumbnail: 'https://blog.udemy.com/wp-content/uploads/2021/02/udemyteamsm.jpg',
        minutesToRead: 6,
    },
];
